import { Button, Popup } from "react-vant";
import { prefix } from ".";
import { IFavorite } from "@/types/menu-types";
import { IShoppingCartInfo } from "@/types/order-types";
import MenuList from "../MenuList";
import { handleNumber, plus } from "@/utils";
import { IDiningMethods } from "@/types/common-types";
import { initialDelivery } from "@/constants";
import { TFunction } from "i18next";
import { useState } from "react";
import TrashIcon from "../svg/TrashIcon";
import TipIcon from "../svg/TipIcon";

interface IShoppingCaetPopupProps {
  data: IFavorite[];
  visible: boolean;
  type: IDiningMethods | undefined;
  shoppingCartData: IShoppingCartInfo | undefined;
  disabled: boolean;
  t: TFunction<"common", undefined>;
  onClose: () => void;
  handleCheckout: () => void;
  handleMinusShoppingCart: (favorite: IFavorite) => void;
  handleAddShoppingCart: (favorite: IFavorite) => void;
  onClearCart: () => void;
};

const ShoppingCaetPopup: React.FC<IShoppingCaetPopupProps> = (props) => {
  const {
    t,
    data,
    type,
    visible,
    shoppingCartData,
    onClose,
    handleMinusShoppingCart,
    handleAddShoppingCart,
    onClearCart,
  } = props;
  
  const [showClearConfirm, setShowClearConfirm] = useState<boolean>(false);
  const { favoriteIdLineItemRef = {} } = shoppingCartData || {};
  const currency = 'HK$';

  let price = 0;
  let totalQuanity = 0;
  let deliveryFee = 0;

  if (type === IDiningMethods.DELIVERY) {
    deliveryFee = initialDelivery;
  }
  Object.values(favoriteIdLineItemRef).forEach(item => {
    const { quantity = 0, total = '0' } = item;
    totalQuanity = plus(totalQuanity, quantity);
    if (!isNaN(Number(total))) {
      price = plus(price, Number(total), 2);
    };
  });

  const list = [
    {
      value: price,
      label: t('subtotal')
    },
    // {
    //   value: deliveryFee,
    //   label: t('deliveryFee')
    // },
    {
      value: plus(price, deliveryFee),
      label: t('total')
    },
  ];

  return (
    <Popup
      visible={visible}
      closeable={false}
      round
      position='bottom'
      style={{ height: '60%' }}
      onClose={onClose}
      className={`${prefix}-popup`}
    >
      <div className={`${prefix}`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-left`}>
            <div className={`${prefix}-title`}>{t('cart')}</div>
            <div className={`${prefix}-subtitle`}>{totalQuanity} {t('items')}</div>
          </div>
          {totalQuanity > 0 && (
            <div className={`${prefix}-header-right`}>
              <TrashIcon 
                className={`${prefix}-trash-icon`}
                onClick={() => setShowClearConfirm(true)}
              />
            </div>
          )}
        </div>
        {
          totalQuanity > 0 &&
          <div className={`${prefix}-content`}>
            <MenuList
              data={data}
              isFirst={false}
              className={`${prefix}-menus`}
              shoppingCartData={shoppingCartData}
              handleMinusShoppingCart={handleMinusShoppingCart}
              handleAddShoppingCart={handleAddShoppingCart}
            />
            <div className={`${prefix}-statistics`}>
              {
                list.map((item, index) => (
                  <div key={item.label} className={`${prefix}-statistics-item ${index === 1 ? 'total' : ''}`}>
                    <div className={`${prefix}-statistics-item-label`}>{item.label}</div>
                    <div className={`${prefix}-statistics-item-value`}>{currency} {handleNumber(item.value)}</div>
                  </div>
                ))
              }
            </div>
          </div>
        }
        {/* <Button onClick={handleCheckout} disabled={disabled || totalQuanity < 1} type='primary'>{t('confirmAndCheckout')}({currency}{price})</Button> */}
      </div>
      <Popup
        visible={showClearConfirm}
        round
        closeable={false}
        position="center"
        onClose={() => setShowClearConfirm(false)}
        className={`${prefix}-clear-confirm-popup`}
      >
        <div className={`${prefix}-clear-confirm`}>
          <TipIcon />
          <div className={`${prefix}-clear-confirm-title`}>{t('clearCartConfirm')}</div>
          <div className={`${prefix}-clear-confirm-buttons`}>
            <Button 
              className={`${prefix}-clear-confirm-button-cancel`}
              onClick={() => setShowClearConfirm(false)}
            >
              {t('cancel')}
            </Button>
            <Button 
              className={`${prefix}-clear-confirm-button-confirm`}
              type="primary"
              onClick={() => {
                onClearCart();
                setShowClearConfirm(false);
              }}
            >
              {t('confirm')}
            </Button>
          </div>
        </div>
      </Popup>
    </Popup>
  )
};

export default ShoppingCaetPopup